import styled from 'styled-components'

const Uploading = styled.div`
  display: inline-flex;
  align-items: center;
  color: #b8b8b8;
  font-size: 14px;
  line-height: 1.5;
`

export const s = { Uploading }
